module.exports = "label {\n    font-weight: normal;\n    margin-top: 10px;\n}\n\n.checkbox {\n    display: inline-block;\n    margin-right: 5px;\n    min-height: 0px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/controls/checkbox/checkbox.component.css
// module id = ./src/app/shared/components/controls/checkbox/checkbox.component.css
// module chunks = main